var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlexibleBw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.9833 32.1833C50.4167 31.95 49.6667 31.8333 48.7333 31.8333H39.9333C37.0333 31.8333 36 32.8666 36 35.8V48.7C36 49.6667 36.1167 50.4166 36.3667 51C36.8833 52.2 37.9833 52.6666 39.9333 52.6666H48.7333C51.6333 52.6666 52.6667 51.6166 52.6667 48.7V35.8C52.6667 33.8166 52.2 32.7 50.9833 32.1833ZM46 48.9166H42.6667C42.6333 48.9166 42.5833 48.9166 42.55 48.9C42.3 48.8833 42.0833 48.8 41.9 48.6333C41.6 48.4166 41.4167 48.0666 41.4167 47.6666C41.4167 46.9833 41.9833 46.4166 42.6667 46.4166H46C46.6833 46.4166 47.25 46.9833 47.25 47.6666C47.25 48.35 46.6833 48.9166 46 48.9166Z",
    fill: "#777777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9834 26.3166V27.6666C50.9834 28.5833 50.2334 29.3333 49.3168 29.3333H39.9334C35.6668 29.3333 33.5001 31.5166 33.5001 35.8V51C33.5001 51.9166 32.7501 52.6666 31.8334 52.6666H28.5834C27.9168 52.6666 27.3834 52.1333 27.3834 51.4833C27.3834 50.8166 27.9168 50.3 28.5834 50.3H31.8334V43.9166H26.0001C22.3001 43.7333 19.3501 40.6833 19.3501 36.9333V26.3166C19.3501 22.4666 22.4834 19.3333 26.3501 19.3333H44.0001C47.8501 19.3333 50.9834 22.4666 50.9834 26.3166Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexibleBw);
export default __webpack_public_path__ + "static/media/flexible-bw.8279329633cb35313b8d59458deaf3d3.svg";
export { ForwardRef as ReactComponent };